<ul class="file-list">
	@for (file of files; track $index) {
		<li class="file-item">
			<span class="file-name">
				<i class="pi pi-file-pdf pdf-icon"></i>
				{{ file.name || "Attachment " + ($index + 1) }}
			</span>
			<p-button
				label="View"
				icon="pi pi-eye"
				[outlined]="true"
				size="small"
				(onClick)="openFile(file.url)"
			/>
		</li>
	}
</ul>

<div class="dialog-footer">
	<p-button
		label="Cancel"
		[text]="true"
		severity="secondary"
		(onClick)="close()"
	/>
	<p-button
		label="View All"
		icon="pi pi-external-link"
		(onClick)="openAll()"
	/>
</div>
